import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';

export default () => {
  return new Vuex.Store({
    state: {
      backend: "https://api-dashboard.oned.io",
      backend2: "http://localhost:3000",
      jwtToken: "xImeD2x3EvG4TzNEH68C_7F8MfqkkskBPlSRtrW7F03g2G8_zxmoNiG3BlHuFvwhqPCsy9E2LhpF4tSyFSVV3_-a138qNFtejdPAFaLd5FUZly9NwnJyAjiDZ3vcxJbj6ie8kAFE_kXYbhbv0Slz2XW6bMWeVY6PB_dw1iFXORvEPsXrBAEUzdA-J9HVabZ_WaguVtkkEQxM1jSdJMIr_Z3bV6HJ-XkXncmFJBih92uL0-GWdutR43oOlxKF4tEw54045evMpQrNlkyZqqUTFRX7jKOv-MZkwHz9CBwz107EjgPW4EOgaDMAIp_6OSklzrKWlJs_0PaOwSUHGjOWHw",
      localToken:"amaz1ngda$hboardapikey",
      generalTotal: 0,
      ruble:[],
      dolar:[],
      tl:[],
      allData: {
        chartData: {},
        overviewData: {}
      },
      threeObject: false,
      sevenObject: true,
      fourTeenObject: false,
      thirtyObject: false,
      oneEightyObject: false,
      itemsData: {},
      trafficData:{},
      mainOverviewsData: {},
      labelCurrency:{},
      selectedService:{},
      selectedData: {},
      optionSelectedService: {},
      selectedSites: {},
      request: false,
      comUser:0,
      comPageview:0,
      comSession:0,
      comRate:0,
      coUser:0,
      coPageview:0,
      coSession:0,
      coRate:0,
      ruUser:0,
      ruPageview:0,
      ruSession:0,
      ruRate:0,
      userName:'',
      overview:'',
      date1:'',
      date2:'',
      /* cachedData:[], */
    },
    mutations,
    actions,
    getters:{
      mainItemsData: state => {
        return state.itemsData
      },
      getMutationOption: state => {
        return state.mutationOption
      }
    }
  })

}
